export default "__VITE_PUBLIC_ASSET__ce2a6498__"